import axios from "axios";

const getSla = async (bid, location, isUrgent, isScheduled, config) => {
    if (isUrgent) {
        return {
            sla: config.urgentSla
        };
    } else if (isScheduled) {
        return {
            scheduledSlaBefore: config.scheduledSlaBefore,
            scheduledSlaAfter: config.scheduledSlaAfter
        }
    } else if (config.isAreaSlaEnabled) {
        const {data: distributionAreas} = await axios.get(`/api/v2/distributionAreas/${bid}`, {
            params: {
                longitude: location.lng,
                latitude: location.lat,
                isReturnFirst: true
            }
        });

        if (distributionAreas.length)
            return {
                sla: distributionAreas[0].sla
            };
    }

    return {
        sla: config.sla
    }
};

export default getSla;